import { z } from 'zod'

export const santosForecastRow = z.object({
  date: z.string(),
  target: z.string(),
  row_type: z.enum(['Historical', 'Forecast']),
  value: z.number().nullable(),
  P10: z.number().nullable(),
  P25: z.number().nullable(),
  P50: z.number().nullable(),
  P75: z.number().nullable(),
  P90: z.number().nullable(),
  weather_temp_afternoon: z.number().nullable(),
})

export type SantosForecastRow = z.infer<typeof santosForecastRow>
